import { useLocation, useNavigate } from "react-router-dom";
import useFetch from "../useFetch";
import { useEffect, useRef, useState } from "react";
import hbricon from "../otherImg/hbrlitenewicon.png";
import { getLastReadingPage, initDB, saveLastReadingPage } from "../ConfigureIndexDB";
import { get, ref } from "firebase/database";
import { realTimeDB } from "../firebase";
import CustomCircularProgress from "../newComponents2/CustomCircularProgressBar";
import { Hbrbackarrow, HbrHalfMoonIcon, HbrShareIcon, HbrSunLightIcon } from "../newComponents/Mycustomsvgicons";
import Cookies from "js-cookie";
import { insertBookAnalytics } from "../newComponents/GeneralClasses";
import { ConstVariables } from "../newComponents2/ConstantVariables";


const EnglishBksRead = () => {
const location = useLocation();
const queryParams = new URLSearchParams(location.search);
const id = queryParams.get("bookid");
const bookLangusage = queryParams.get("language");
const bookTitle = queryParams.get("booktitle");
const [pdfBookData,setPdfBookData] = useState({title:"", url:"", cover:"", audio:""});
const [isRendering, setIsRendering] = useState(false);
const [nightMode,setNightmode] = useState(false);
const parentRef = useRef();
const audioRef = useRef();
const iframeRef = useRef(null);
const navigate = useNavigate();

const {data: nonPdfBook, ispending, fallBackToPdfView} = useFetch(`${process.env.REACT_APP_BOOKS_SERVER_URL}/books/${id}`);

useEffect(()=>{
    async function fetchBook() {
        if (fallBackToPdfView && bookLangusage && bookTitle) {
            setIsRendering(true);
            const bookRef_name = bookLangusage === "english" 
            ? "Books english" : bookLangusage === "french" 
            ? "Books french" : bookLangusage === "filipino"
            ? "Books filipino" : bookLangusage === "spanish"
            ? "Books spanish" : bookLangusage === "german"
            ? "Books german" : "empty ref";
      
            const purifyBookTitle = bookTitle.replace("%20"," ");
            const books_snapshot = await get(ref(realTimeDB,`${bookRef_name}`));
            if (books_snapshot.exists()) {
                const books = books_snapshot.val();
                for(const key in books){
                    if (books[key].name === purifyBookTitle) {
                        setPdfBookData({
                            title: books[key].name,
                            url: books[key].url,
                            cover: books[key].bookcover
                        });
                        setIsRendering(false);
                        break;
                    }
                }
            }
        }
    }
    fetchBook();
},[bookLangusage, bookTitle, fallBackToPdfView]);

const shareBlogPost=async()=>{
  if(navigator.share){
      try{
          await navigator.share({
              title: `${pdfBookData && pdfBookData.title}`,
              text: `Check out this book and your life will never be the same. Very inspiring and crucial for our eternal life.`,
              url: `https://horemowbookreaderlite.web.app/hbrbooks?language=${bookLangusage}&booktitle=${pdfBookData?.title}&bookid=${id}`,
          });
          insertBookAnalytics(bookTitle, ConstVariables.SHARES);
      }catch{
      }
  }else{
  }
}; 

const handleScroll=async(e)=>{
    const scrollTop = e.target.scrollTop;
    await initDB();
    await saveLastReadingPage({
        id: `${id}`,
        currentPage: scrollTop,
        audioTime: pdfBookData?.audio && audioRef.current.currentTime
    });
};

const handleReadingTheme=async()=>{
    setNightmode(prev => !prev);
    Cookies.set("reading theme",nightMode);
};

useEffect(() => {
    async function getLastPageRead() {
        await initDB();
        const res = await getLastReadingPage(`${id}`);
        if (res) {
            const timeid = setTimeout(() => {
                try{
                    parentRef.current.scrollTop = res.currentPage;
                    if(res.audioTime){
                        audioRef.current.currentTime = res.audioTime;
                    }
                }catch{
              
                }
            }, 2000);
            return () => clearTimeout(timeid);
        }
    }
    const readingTheme = Cookies.get("reading theme");
    readingTheme ? setNightmode(true) : setNightmode(false);
    getLastPageRead();
  }, [id]);

  const closePage=()=>{
    if (location.state && location.state.from) {
        navigate(location.state.from);
    }else{
        navigate("/");
    }
  };

//   useEffect(()=>{
//     const handlePdfScroll = async () =>{
//         const pdfIframe = iframeRef.current;
//         if (pdfIframe) {
//             const scrollTop = pdfIframe.contentWindow.document.documentElement.scrollTop;
//             await initDB();
//             await saveLastReadingPage({
//                 id: `${id}`,
//                 currentPage: scrollTop,
//             });
//         }
//     };
//     const pdfIframe = iframeRef.current;
//     if (pdfIframe) {
//         try {
//             pdfIframe.addEventListener('load', () => {
//                 try {
//                     pdfIframe.contentWindow.addEventListener('scroll',handlePdfScroll);
//                 } catch{
                    
//                 }
               
//                 //restore position
//                 initDB().then(async()=>{
//                     const lastReadingPage = await getLastReadingPage(`${id}`);
//                     if (lastReadingPage) {
//                         pdfIframe.contentWindow.scrollTo(0, lastReadingPage.currentPage)
//                     }
//                 })
//             });
//         } catch (error) {
            
//         }
//     }

//     return ()=>{
//         if (pdfIframe) {
//             try {
//                 pdfIframe.contentWindow.removeEventListener('scroll',handlePdfScroll);
//             } catch (error) {
                
//             }
//         }
//     };
// },[id]);


    return (
        <div className={`readingpage ${nightMode? 'nightmode':'normal'}`}>
            {isRendering && 
            <div style={{position:"fixed",top:"30%",left:"40%"}}> 
                <CustomCircularProgress borderColor={"#ffffff50"} borderTopColor={"#eb268f"} borderBottomColor={"#0b6b93"} top={"30%"} left={"44%"} />
            </div>
            } 
            {ispending && 
            <div style={{position:"fixed",top:"30%",left:"40%"}}> 
                <CustomCircularProgress borderColor={"#ffffff50"} borderTopColor={"#eb268f"} borderBottomColor={"#0b6b93"} top={"30%"} left={"44%"} />
            </div>
            } 

            <div className={`readingpagetop ${nightMode? 'nightmode':'normal'}`}>
                    
                    {!fallBackToPdfView && nonPdfBook?.audio !== "" && 
                    <div className="content-audio">
                        <audio src={nonPdfBook?.audio} controls ref={audioRef}/>
                        <p style={{color: "black"}}>Listen to Audio</p>
                    </div>
                    }

                    <div className="readingpagetopmenus flex-row2">
                        <Hbrbackarrow width={"1.7em"} height={"1.7em"} fillColour={nightMode ? 'white': 'black'} handleClick={()=>closePage()}/>

                        {!ispending && !fallBackToPdfView &&
                            (
                            <div>
                                {!nightMode ?
                                    <div className="togglenight" onClick={handleReadingTheme}>
                                        <HbrHalfMoonIcon width={"2em"} height={"2em"} fillColour={"black"}/>
                                        <h4 style={{color:"white"}}>Night Light</h4>
                                    </div>
                                    :
                                    <div className="toggleday" onClick={handleReadingTheme}>
                                        <HbrSunLightIcon width={"2em"} height={"2em"} fillColour={"white"}/>
                                        <h4>Day Light</h4>
                                    </div>
                                }     
                            </div>
                            )
                        }

                          <HbrShareIcon width={"2em"} height={"2em"} fillColour={nightMode ? 'white': 'black'} handleClick={()=>shareBlogPost()}/>
                    </div>

                    <div className="pagetoplogo flex-row2">
                        <h4 style={{color:"teal"}}>hbr<span style={{color:"#eb268f"}}>LiTE</span></h4> 
                        <img src={hbricon} alt=""/>
                    </div>
          </div>

          <div className={`readingpagetop-phone ${nightMode? 'nightmode':'normal'}`}>
                    
                    {!fallBackToPdfView && nonPdfBook?.audio !== "" && 
                    <div className="content-audio">
                    <audio src={nonPdfBook?.audio} controls ref={audioRef} controlsList="nodownload"/>
                    <p style={{color: "black"}}>Listen to Audio</p>
                    </div>
                    }

                    <div className="readingpagetopmenus flex-row2">
                        <Hbrbackarrow width={"1.7em"} height={"1.7em"} fillColour={nightMode ? 'white': 'black'} handleClick={()=>closePage()}/>
                        {!ispending && !fallBackToPdfView &&
                            (
                            <div>
                                {!nightMode ?
                                    <div className="togglenight" onClick={handleReadingTheme}>
                                        <HbrHalfMoonIcon width={"2em"} height={"2em"} fillColour={"black"}/>
                                        <h4 style={{color:"white", fontSize:"small"}}>Night Light</h4>
                                    </div>
                                    :
                                    <div className="toggleday" onClick={handleReadingTheme}>
                                        <HbrSunLightIcon width={"2em"} height={"2em"} fillColour={"white"}/>
                                        <h4 style={{color:"white", fontSize:"small"}}>Day</h4>
                                    </div>
                                }     
                            </div>
                            )
                        }

                        <HbrShareIcon width={"1.7em"} height={"1.7em"} fillColour={nightMode ? 'white': 'black'} handleClick={()=>shareBlogPost()}/>
                        
                    </div>
          </div>
                    

            {fallBackToPdfView && pdfBookData?.url !== "" && (
            <div className={`reading-layout ${nightMode? 'nightmode':'normal'}`} 
                onScroll={handleScroll} ref={parentRef}>
                <iframe 
                src={pdfBookData?.url} 
                width={"100%"} 
                height={"100%"} 
                title={pdfBookData?.title}
                // sandbox="allow-same-origin"
                ref={iframeRef}/>
            </div>
            )}

            {!fallBackToPdfView && (
                <div className={`reading-layout ${nightMode? 'nightmode':'normal'}`} 
                        onScroll={handleScroll} ref={parentRef}>
                    <article >
                        <h2>{nonPdfBook?.title}</h2>
                        <img src={nonPdfBook?.image} alt=""/>
                        <pre>{nonPdfBook?.bookcontent}</pre>
                    </article>
                </div>
            )}
        </div>
      );
}
export default EnglishBksRead;